var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ncm)?_c('div',{staticClass:"ncm-container"},[_c('label',[_vm._v("NCM")]),_c('div',[_vm._v(_vm._s(_vm.ncm))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }